/* eslint-disable @typescript-eslint/no-extraneous-class */

/* eslint-disable import/no-extraneous-dependencies */
import toCamelcase from 'to-camel-case';
import kebabCase from 'lodash/kebabCase';
import lowerCase from 'lodash/lowerCase';
import snakeCase from 'lodash/snakeCase';
import startCase from 'lodash/startCase';
import upperCase from 'lodash/upperCase';
import upperFirst from 'lodash/upperFirst';

/* eslint-enable import/no-extraneous-dependencies */
export class StringCase {
    static toCamelCase(str: string) {
        return toCamelcase(str);
    }

    static toSnakeCase(str: string) {
        return snakeCase(str);
    }

    static toTitleCase(str: string) {
        return startCase(toCamelcase(str));
    }

    static toPascalCase(str: string) {
        return startCase(toCamelcase(str)).replace(/ /g, '');
    }

    static toConstantCase(str: string) {
        return upperCase(str).replace(/ /g, '_');
    }

    static toDotCase(str: string) {
        return lowerCase(str).replace(/ /g, '.');
    }

    static toKebabCase(str: string) {
        return kebabCase(str);
    }

    static toLowerCase(str: string) {
        return lowerCase(str).replace(/ /g, '');
    }

    static toPathCase(str: string) {
        return lowerCase(str).replace(/ /g, '/');
    }

    static toSentenceCase(str: string) {
        return upperFirst(lowerCase(str));
    }
}
